import React from "react";

const Shipping = () => {
   return(<h1>This is Shipping</h1>);
};
export default Shipping;